export default {"src":"/_next/static/media/how-to-use-icon-2.5dbfa15e.svg","height":65,"width":42,"blurWidth":0,"blurHeight":0};